import * as React from 'react'
import styled, { css, useTheme } from 'styled-components'

import { TypeStyle, focusOutline } from '@syconium/little-miss-figgy'

const fontStyles = css`
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 2px;
  text-transform: uppercase;
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${o => o.theme.spacing(5)};
`

export const ActionsBar = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`

export const ToggleAddEmbroideryButton = styled.button`
  align-items: center;
  display: flex;
  outline: none;
  &:disabled {
    cursor: default;
  }

  ${focusOutline}
`

export const ToggleAddEmbroideryCheckbox = styled.div<{ isDisabled?: boolean }>`
  align-items: center;
  border: ${o => (o.isDisabled ? undefined : '2px solid black')};
  box-sizing: border-box;
  display: flex;
  height: 14px;
  justify-content: center;
  outline: none;
  width: 14px;
  background-color: ${o => (o.isDisabled ? o.theme.color.fill.disabled.subtle : undefined)};
  border-radius: ${o => (o.isDisabled ? '2px' : undefined)};
  cursor: ${o => (o.isDisabled ? 'not-allowed' : undefined)};

  svg {
    bottom: 1px;
    position: relative;
  }
`

export const EmbroideryCheckmark: React.FC<{ isDisabled?: boolean }> = ({ isDisabled }) => {
  const theme = useTheme()

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='10' height='7' viewBox='0 0 10 7'>
      <path
        fill='none'
        fillRule='evenodd'
        stroke={
          isDisabled
            ? theme.color.stroke.neutral.border.interaction.secondary.on.background
            : '#000'
        }
        strokeWidth={isDisabled ? '1' : '2'}
        d='M4 3L4 7 10 7'
        transform='rotate(-45 2.379 5.914)'
      />
    </svg>
  )
}

export const ToggleAddEmbroideryText = styled.span`
  ${fontStyles}
  margin-inline-start: 6px;
`

export const RightButtons = styled.div`
  ${fontStyles}
  align-items: center;
  display: flex;
  justify-content: center;
`

export const EditButton = styled.button<{ isOnlyButton?: boolean }>`
  ${fontStyles}
  border-inline-end: ${o => (o.isOnlyButton ? undefined : '1px solid black')};
  outline: none;
  padding-inline-start: 12px;
  padding-inline-end: 8px;

  ${focusOutline}
`

export const TrashButton = styled.button`
  align-items: center;
  display: flex;
  justify-content: center;
  outline: none;
  padding-inline-start: 8px;

  ${focusOutline}
`

export const PortalDiscountText = styled(TypeStyle.HeadlineMicro)`
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  font-weight: ${o => o.theme.typography.deprecated.font.weight.normal};
`
